import React from 'react';

import { Box, Text, Button } from 'src/Components/Base';
import { SPACE } from 'src/Components/Theme';

const NotFound = ({ location, history }) => (
  <Box p={SPACE.large} style={{ textAlign: 'center' }}>
    <Text.Title mb={SPACE.medium}>Error 404 Page not found!</Text.Title>
    <Button primary cicular onClick={() => history.push('/')}>
      กลับสู่หน้าหลัก
    </Button>
  </Box>
);

export default NotFound;
